/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/products/product
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyCartLineItemKey,
  ShopifyCartLineItemToProductKey,
  ShopifyCheckoutLineItemKey,
  ShopifyCheckoutLineItemToProductKey,
  ShopifyCollectionKey,
  ShopifyCollectionToProductsKey,
  ShopifyCollectKey,
  ShopifyCollectToCollectionKey,
  ShopifyCollectToProductKey,
  ShopifyDiscountCustomerBuysProductKey,
  ShopifyDiscountCustomerBuysProductToDiscountKey,
  ShopifyDiscountCustomerBuysProductToProductKey,
  ShopifyDiscountCustomerGetsProductKey,
  ShopifyDiscountCustomerGetsProductToDiscountKey,
  ShopifyDiscountCustomerGetsProductToProductKey,
  ShopifyDiscountKey,
  ShopifyDiscountToCustomerBuysProductKey,
  ShopifyDiscountToCustomerGetsProductKey,
  ShopifyDraftOrderLineItemKey,
  ShopifyDraftOrderLineItemToProductKey,
  ShopifyFeaturedProductMediaToProductKey,
  ShopifyFileKey,
  ShopifyFileToProductKey,
  ShopifyOrderLineItemKey,
  ShopifyOrderLineItemToProductKey,
  ShopifyProductImageKey,
  ShopifyProductImageToProductKey,
  ShopifyProductKey,
  ShopifyProductMediaKey,
  ShopifyProductMediaToFileKey,
  ShopifyProductMediaToProductKey,
  ShopifyProductOptionKey,
  ShopifyProductOptionToProductKey,
  ShopifyProductToCartLineItemsKey,
  ShopifyProductToCheckoutLineItemsKey,
  ShopifyProductToCollectionsKey,
  ShopifyProductToCustomerBuysProductKey,
  ShopifyProductToCustomerGetsProductKey,
  ShopifyProductToDraftOrderLineItemsKey,
  ShopifyProductToFileKey,
  ShopifyProductToOrderLineItemsKey,
  ShopifyProductToSellingPlanGroupKey,
  ShopifyProductToShopKey,
  ShopifyProductVariantKey,
  ShopifyProductVariantToProductKey,
  ShopifySellingPlanGroupKey,
  ShopifySellingPlanGroupProductKey,
  ShopifySellingPlanGroupProductToProductKey,
  ShopifySellingPlanGroupProductToSellingPlanGroupKey,
  ShopifySellingPlanGroupToProductKey,
  ShopifyShopKey,
} from "./keys";
import type { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

// we removed graphql only fields from the model spec which changes how the static keys are generated. these are here so that they remain the same
const categoryKey = "ModelField-DataModel-Shopify-Product-__gadget_graphql_category";
const categoryStorageEpochKey = "FieldStorageEpoch-DataModel-Shopify-Product-__gadget_graphql_category-initial";
const compareAtPriceRangeKey = "ModelField-DataModel-Shopify-Product-__gadget_graphql_compare_at_price_range";
const compareAtPriceRangeStorageEpochKey = "FieldStorageEpoch-DataModel-Shopify-Product-__gadget_graphql_compare_at_price_range-initial";
const productCategoryKey = "ModelField-DataModel-Shopify-Product-__gadget_graphql_product_category";
const productCategoryStorageEpochKey = "FieldStorageEpoch-DataModel-Shopify-Product-__gadget_graphql_product_category-initial";
const hasVariantsThatRequiresComponentsKey = "ModelField-DataModel-Shopify-Product-__gadget_graphql_has_variants_that_requires_components";
const hasVariantsThatRequiresComponentsStorageEpochKey =
  "FieldStorageEpoch-DataModel-Shopify-Product-__gadget_graphql_has_variants_that_requires_components-initial";

export const DefaultFilterableApiIdentifiers = [
  "body",
  "category",
  "handle",
  "productType",
  "publishedAt",
  "status",
  "tags",
  "title",
  "vendor",
];
export const DefaultSearchableApiIdentifiers = ["body", "category", "handle", "productType", "tags", "title", "vendor"];

const specs: ConnectionModelSpecVersion = {
  key: ShopifyProductKey,
  defaultSearchableApiIdentifiers: DefaultSearchableApiIdentifiers,
  defaultFilterableApiIdentifiers: DefaultFilterableApiIdentifiers,
  "2022-01": {
    name: "Shopify Product",
    graphQLTypename: "Product",
    hasMetafields: true,
    fields: [
      {
        name: "Body",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "body_html" } },
      },
      {
        // The Shopify API doesn't allow querying Smart Collections via `Collects`
        name: "Custom Collections",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyProductToCollectionsKey,
        configuration: {
          joinModelKey: ShopifyCollectKey,
          relatedModelKey: ShopifyCollectionKey,
          inverseJoinModelFieldKey: ShopifyCollectToProductKey,
          inverseRelatedModelFieldKey: ShopifyCollectToCollectionKey,
          inverseFieldKey: ShopifyCollectionToProductsKey,
        },
      },
      {
        name: "Cart Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyProductToCartLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyCartLineItemKey,
          inverseFieldKey: ShopifyCartLineItemToProductKey,
        },
      },
      {
        name: "Draft Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyProductToDraftOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyDraftOrderLineItemKey,
          inverseFieldKey: ShopifyDraftOrderLineItemToProductKey,
        },
      },
      {
        name: "Order Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyProductToOrderLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyOrderLineItemKey,
          inverseFieldKey: ShopifyOrderLineItemToProductKey,
        },
      },
      {
        name: "Handle",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "handle" } },
      },
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Images",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "images" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyProductImageKey,
          inverseFieldKey: ShopifyProductImageToProductKey,
        },
      },
      {
        name: "Options",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "options" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyProductOptionKey,
          inverseFieldKey: ShopifyProductOptionToProductKey,
        },
      },
      {
        name: "Product Type",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "product_type" } },
      },
      {
        name: "Published At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "published_at" } },
      },
      {
        name: "Published Scope",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "published_scope" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        configuration: {
          allowMultiple: false,
          options: [{ name: "active" }, { name: "archived" }, { name: "draft" }],
        },
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "status" } },
      },
      {
        name: "Tags",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tags" } },
      },
      {
        name: "Template Suffix",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "template_suffix" } },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "title" } },
      },
      {
        name: "Variants",
        fieldType: FieldType.HasMany,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "variants" } },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyProductVariantKey,
          inverseFieldKey: ShopifyProductVariantToProductKey,
        },
      },
      {
        name: "Vendor",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "vendor" } },
      },
      {
        name: "Checkout Line Items",
        fieldType: FieldType.HasMany,
        key: ShopifyProductToCheckoutLineItemsKey,
        configuration: {
          relatedModelKey: ShopifyCheckoutLineItemKey,
          inverseFieldKey: ShopifyCheckoutLineItemToProductKey,
        },
      },
      {
        name: "Selling Plan Groups",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyProductToSellingPlanGroupKey,
        configuration: {
          joinModelKey: ShopifySellingPlanGroupProductKey,
          relatedModelKey: ShopifySellingPlanGroupKey,
          inverseJoinModelFieldKey: ShopifySellingPlanGroupProductToProductKey,
          inverseRelatedModelFieldKey: ShopifySellingPlanGroupProductToSellingPlanGroupKey,
          inverseFieldKey: ShopifySellingPlanGroupToProductKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyProductToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "product" },
  },
  "2022-10": {
    fields: [
      {
        name: "Product Category",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_product_category",
            graphQLFieldKey: "productCategory",
            graphQLOnlyField: true,
            graphQLSelection: `productTaxonomyNode { fullName id isLeaf isRoot name }`,
          },
        },
      },
    ],
  },
  "2023-07": {
    fields: [
      {
        name: "Customer Gets Through Discounts",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyProductToCustomerGetsProductKey,
        configuration: {
          joinModelKey: ShopifyDiscountCustomerGetsProductKey,
          relatedModelKey: ShopifyDiscountKey,
          inverseJoinModelFieldKey: ShopifyDiscountCustomerGetsProductToProductKey,
          inverseRelatedModelFieldKey: ShopifyDiscountCustomerGetsProductToDiscountKey,
          inverseFieldKey: ShopifyDiscountToCustomerGetsProductKey,
        },
      },
      {
        name: "Customer Buys Through Discounts",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyProductToCustomerBuysProductKey,
        configuration: {
          joinModelKey: ShopifyDiscountCustomerBuysProductKey,
          relatedModelKey: ShopifyDiscountKey,
          inverseJoinModelFieldKey: ShopifyDiscountCustomerBuysProductToProductKey,
          inverseRelatedModelFieldKey: ShopifyDiscountCustomerBuysProductToDiscountKey,
          inverseFieldKey: ShopifyDiscountToCustomerBuysProductKey,
        },
      },
    ],
  },
  "2023-10": {
    fields: [
      {
        name: "Compare At Price Range",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "__gadget_graphql_compare_at_price_range",
            graphQLFieldKey: "compareAtPriceRange",
            graphQLOnlyField: true,
            graphQLSelection: `
            minVariantCompareAtPrice { amount currencyCode }
            maxVariantCompareAtPrice { amount currencyCode }
            `,
          },
        },
      },
    ],
  },
  "2024-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id" } },
      },
      {
        name: "Body",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "body_html", graphQLFieldKey: "descriptionHtml" } },
      },
      {
        name: "Handle",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "handle", graphQLFieldKey: "handle" } },
      },
      {
        name: "Product Type",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "product_type", graphQLFieldKey: "productType" } },
      },
      {
        name: "Published At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "published_at", graphQLFieldKey: "publishedAt" } },
      },
      {
        name: "Published Scope",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "published_scope" } },
        isDeleted: true,
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at", graphQLFieldKey: "createdAt" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at", graphQLFieldKey: "updatedAt" } },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "active" }, { name: "archived" }, { name: "draft" }],
        },
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "status", graphQLFieldKey: "status", isShopifyEnum: true } },
      },
      {
        name: "Tags",
        fieldType: FieldType.JSON,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "tags", graphQLFieldKey: "tags" } },
      },
      {
        name: "Template Suffix",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "template_suffix", graphQLFieldKey: "templateSuffix" } },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "title", graphQLFieldKey: "title" } },
      },
      {
        name: "Vendor",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "vendor", graphQLFieldKey: "vendor" } },
      },
      {
        name: "Options",
        fieldType: FieldType.HasMany,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "options",
            graphQLFieldKey: "options",
            graphQLSelection: `id name position values`,
            selectForHasMany: true,
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyProductOptionKey,
          inverseFieldKey: ShopifyProductOptionToProductKey,
        },
      },
      {
        key: productCategoryKey,
        initialStorageEpochKey: productCategoryStorageEpochKey,
        name: "Product Category",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "productCategory",
            graphQLSelection: `productTaxonomyNode { fullName id isLeaf isRoot name }`,
            deprecated: true,
          },
        },
      },
      {
        key: categoryKey,
        initialStorageEpochKey: categoryStorageEpochKey,
        name: "Category",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "category",
            graphQLSelection: `id name ancestorIds childrenIds fullName isArchived isLeaf isRoot level parentId`,
          },
        },
      },
      {
        key: compareAtPriceRangeKey,
        initialStorageEpochKey: compareAtPriceRangeStorageEpochKey,
        name: "Compare At Price Range",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "compareAtPriceRange",
            graphQLSelection: `
            minVariantCompareAtPrice { amount currencyCode }
            maxVariantCompareAtPrice { amount currencyCode }
            `,
          },
        },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "products",
      filters: {
        updatedAt: { sortKey: "UPDATED_AT" },
        createdAt: { sortKey: "CREATED_AT" },
      },
      sortableBy: {
        updatedAt: { sortKey: "UPDATED_AT", reverse: true },
        createdAt: { sortKey: "CREATED_AT", reverse: true },
        id: { sortKey: "ID", reverse: false },
        inventoryTotal: { sortKey: "INVENTORY_TOTAL", reverse: true },
        productType: { sortKey: "PRODUCT_TYPE", reverse: false },
        publishedAt: { sortKey: "PUBLISHED_AT", reverse: true },
        relevance: { sortKey: "RELEVANCE", reverse: false },
        title: { sortKey: "TITLE", reverse: false },
        vendor: { sortKey: "VENDOR", reverse: false },
      },
    },
  },
  "2024-07": {
    fields: [
      {
        name: "Media",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyProductToFileKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "media" },
        },
        configuration: {
          joinModelKey: ShopifyProductMediaKey,
          relatedModelKey: ShopifyFileKey,
          inverseJoinModelFieldKey: ShopifyProductMediaToProductKey,
          inverseRelatedModelFieldKey: ShopifyProductMediaToFileKey,
          inverseFieldKey: ShopifyFileToProductKey,
          dependent: "delete",
        },
      },
      {
        name: "Featured Media",
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "featuredMedia", graphQLSelection: "id" },
        },
        configuration: {
          relatedModelKey: ShopifyProductMediaKey,
          inverseFieldKey: ShopifyFeaturedProductMediaToProductKey,
        },
      },
      {
        key: hasVariantsThatRequiresComponentsKey,
        initialStorageEpochKey: hasVariantsThatRequiresComponentsStorageEpochKey,
        name: "Has Variants That Requires Components",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "hasVariantsThatRequiresComponents",
          },
        },
      },
    ],
  },
  "2024-10": {
    fields: [
      // As of shopify version 2024-10 shopify sends category in product webhooks
      // We want the graphql and rest versions of this field to match and so we do a limited selection in the graphql field
      {
        key: categoryKey,
        initialStorageEpochKey: categoryStorageEpochKey,
        name: "Category",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "category",
            graphQLFieldKey: "category",
            graphQLSelection: `id name fullName`,
          },
        },
      },
    ],
  },
  "2025-01": {
    fields: [
      {
        name: "SEO",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "seo",
            graphQLSelection: `
            description
            title
            `,
          },
        },
      },
    ],
  },
  "2025-04": {
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "id",
            graphQLFieldKey: "id",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Body",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "body_html",
            graphQLFieldKey: "descriptionHtml",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Handle",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "handle",
            graphQLFieldKey: "handle",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Product Type",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "product_type",
            graphQLFieldKey: "productType",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Published At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "published_at",
            graphQLFieldKey: "publishedAt",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        key: categoryKey,
        initialStorageEpochKey: categoryStorageEpochKey,
        name: "Category",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "category",
            graphQLFieldKey: "category",
            graphQLSelection: `id name fullName`,
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        key: hasVariantsThatRequiresComponentsKey,
        initialStorageEpochKey: hasVariantsThatRequiresComponentsStorageEpochKey,
        name: "Has Variants That Requires Components",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "hasVariantsThatRequiresComponents",
            shopifyFieldKey: "has_variants_that_requires_components",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Title",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "title",
            graphQLFieldKey: "title",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Vendor",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "vendor",
            graphQLFieldKey: "vendor",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Options",
        fieldType: FieldType.HasMany,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "options",
            graphQLFieldKey: "options",
            graphQLSelection: `id name position values`,
            selectForHasMany: true,
            availableInWebhook: ["products/create", "products/update"],
          },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyProductOptionKey,
          inverseFieldKey: ShopifyProductOptionToProductKey,
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
            graphQLFieldKey: "updatedAt",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Status",
        fieldType: FieldType.Enum,
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "ACTIVE" }, { name: "ARCHIVED" }, { name: "DRAFT" }],
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "status",
            graphQLFieldKey: "status",
            isShopifyEnum: true,
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Tags",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "tags",
            graphQLFieldKey: "tags",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Template Suffix",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "template_suffix",
            graphQLFieldKey: "templateSuffix",
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
      {
        name: "Variants",
        fieldType: FieldType.HasMany,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "variants", availableInWebhook: ["products/create", "products/update"] },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyProductVariantKey,
          inverseFieldKey: ShopifyProductVariantToProductKey,
        },
      },
      {
        name: "Images",
        fieldType: FieldType.HasMany,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "images", availableInWebhook: ["products/create", "products/update"] },
        },
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyProductImageKey,
          inverseFieldKey: ShopifyProductImageToProductKey,
        },
      },
      {
        name: "Media",
        fieldType: FieldType.HasManyThrough,
        key: ShopifyProductToFileKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "media", availableInWebhook: ["products/create", "products/update"] },
        },
        configuration: {
          joinModelKey: ShopifyProductMediaKey,
          relatedModelKey: ShopifyFileKey,
          inverseJoinModelFieldKey: ShopifyProductMediaToProductKey,
          inverseRelatedModelFieldKey: ShopifyProductMediaToFileKey,
          inverseFieldKey: ShopifyFileToProductKey,
          dependent: "delete",
        },
      },
      {
        name: "Featured Media",
        fieldType: FieldType.HasOne,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "featuredMedia",
            graphQLSelection: "id",
            availableInWebhook: {
              "products/create": "media.position",
              "products/update": "media.position",
            },
          },
        },
        configuration: {
          relatedModelKey: ShopifyProductMediaKey,
          inverseFieldKey: ShopifyFeaturedProductMediaToProductKey,
        },
      },
    ],
  },
  "2025-10": {
    fields: [
      {
        name: "Status",
        fieldType: FieldType.Enum,
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [{ name: "ACTIVE" }, { name: "ARCHIVED" }, { name: "DRAFT" }, { name: "UNLISTED" }],
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "status",
            graphQLFieldKey: "status",
            isShopifyEnum: true,
            availableInWebhook: ["products/create", "products/update"],
          },
        },
      },
    ],
  },
};

export const ShopifyProduct = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
